import { HStack, Modal,VStack } from "native-base"
import { useEffect, useState } from "react"
import { TextField,FormControl,Select,MenuItem,InputLabel,DialogTitle, Dialog,DialogActions,IconButton, DialogContent,Button,Alert } from "@mui/material"
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CloseIcon from '@mui/icons-material/Close'
import dayjs from "dayjs";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Notiflix from "notiflix";
import { validatePhoneBooking, addMinutesHHmm, DEFAULT_DURATION_MIN } from "../services/reservationsApi";
//props : open,biz,onClose,onsave
import { styled } from '@mui/material/styles';






const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
//   export interface DialogTitleProps {
//     id: string;
//     children?: React.ReactNode;
//     onClose: () => void;
//   }
  
  function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;
  
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }
  

const EditReservationModal =(props)=>{

    // The venue loads asynchronously; never assume it's there yet.
    const biz = props.biz || null


    const defaultReservation ={
        "timeFrom": "",
        "bizName": biz?.bizName || "",
        "bizAddress": biz?.bizAddress || "",
        "reservationStatus": "pending",
        "area": "",
        "date": "",
        "reservationDate": "",
        "numberOfPeople": 0,
        "payAmount": 5,
        "tableMode": "",
        "userId": "",
        "dishes": [],
        "userPhone": "",
        "username": "",
        "bizId": biz?.bizId || "",
        "userEmail": "",
        "timeTo": "",
        "accessibilityNotes": "",
        "occasion": ""
    }
   const [reservation,setReservation]= useState(
    {
        ...defaultReservation
    }
   )

   useEffect(()=>{
    if(props.reservation){
        setReservation({...props.reservation})
    }

   },[props.reservation])

   useEffect(()=>{
    if(!props.reservation && props.biz ){
        setReservation({...defaultReservation})
    }
   },[props.reservation,props.biz])


   const [saving, setSaving] = useState(false)
   const [saveError, setSaveError] = useState("")

   const handle_close =()=>{
    if (saving) return
    setReservation(defaultReservation)
    setSaveError("")
    props.onClose()

   }

   // Same required fields as the staff reservation API (no userId: phone
   // bookings have no app customer).
   const isEdit = !!props.reservation
   // On app bookings the customer's own details can't be changed by staff.
   const customerLocked = isEdit && props.reservation.source !== 'venue_phone'
   // canceled / removed are final; the API rejects later changes
   const isFinal = isEdit && ['canceled','removed'].includes(props.reservation.reservationStatus)

   // Waits for the save. The page closes the modal only on success; on
   // failure the modal stays open with the server's message and the user's input.
   const handle_save=async (r)=>{
      const problems = validatePhoneBooking(r)
      if(problems.length > 0){
        Notiflix.Report.Warning(
            "Warning",
            `Please check: ${problems.join(", ")}`,
            "Close"
          );
        return
      }
      setSaving(true)
      setSaveError("")
      let result
      try {
        result = await props.onSave(r)
      } catch (e) {
        result = { ok: false, message: `${e?.message || e}` }
      }
      setSaving(false)
      if (result && result.ok) {
        setReservation(defaultReservation)
      } else if (result && !result.cancelled) {
        setSaveError(result.message || "The booking couldn't be saved. Please try again.")
      }
    }

   // Time To follows Time From (+2h) until the user sets it themselves.
   const [timeToAuto, setTimeToAuto] = useState(!props.reservation)
   useEffect(() => { setTimeToAuto(!props.reservation) }, [props.reservation])
   const handleTimeFrom = (value) => {
     setReservation((r) => ({
       ...r,
       timeFrom: value,
       ...(timeToAuto && /^\d{2}:\d{2}$/.test(value) ? { timeTo: addMinutesHHmm(value, DEFAULT_DURATION_MIN) } : {}),
     }))
   }
   const handleTimeTo = (value) => {
     setTimeToAuto(false)
     setReservation((r) => ({ ...r, timeTo: value }))
   }



    return(
        <>
             <BootstrapDialog
                 
                  open={props.open}
                  size={"md"}
                  onClose={handle_close}
                  
                >
                
                    {
                        props.reservation?
                        <BootstrapDialogTitle id="customized-dialog-title" onClose={handle_close}>
                            Edit Reservation
                        </BootstrapDialogTitle>
                        :
                        <BootstrapDialogTitle id="customized-dialog-title" onClose={handle_close}>
                            Add Reservation
                        </BootstrapDialogTitle>
                    }
                   
                    <DialogContent dividers>
                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
                      
                      <TextField 
                      id="customer-basic"
                       label="Customer"
                       disabled={customerLocked}
                       fullWidth
                       value={reservation['username']}
                        onChange={(event) => {
                            setReservation(
                                (reservation)=>{
                                
                                return {
                                    ...reservation,
                                    username:event.target.value
                                }
                                }
                            )
                        }}
                        variant="outlined"
                       sx={{
                        margin:1
                       }}
                         />
                          <TextField 
                            id="numberofpeople"
                            label="No of People"
                            value={reservation['numberOfPeople']}
                            onChange={(event) => {
                                const e = event.target.value
                                setReservation(
                                    (reservation)=>{
                                     
                                     return {
                                         ...reservation,
                                         numberOfPeople: isNaN(e)?0:parseInt(e)
                                     }
                                    }
                                 )
                            }

                            
                        }
                                variant="outlined"
                                sx={{
                                    margin:1
                                   }}
                         />

                         <TextField 
                            id="user-email"
                            fullWidth
                            label="Customer Email"
                            disabled={customerLocked}
                            value={reservation['userEmail']}
                            onChange={(event) => {
                                const e = event.target.value
                                setReservation(
                                    (reservation)=>{
                                     
                                     return {
                                         ...reservation,
                                         userEmail: e
                                     }
                                    }
                                 )
                                }  
                            }
                            variant="outlined"
                            sx={{
                                margin:1
                                }}
                            
                         />

                         <TextField

                            value={reservation['userPhone']}
                            label={'Customer Phone'}
                            disabled={customerLocked}

                            onChange={(event)=>{
                                const e = event.target.value
                                setReservation(
                                    (reservation)=>{
                                        return {
                                            ...reservation,
                                            userPhone:e
                                        }
                                    }
                                )
                            }}
                            sx={{
                                margin:1
                            }}
                         />

                    <FormControl   sx={{
                        margin:1,
                        minWidth:120
                       }}>

                    {
                        props.reservation?
                        <>
                    <InputLabel id="input-age">Status</InputLabel>
                    <Select
                        labelId="age-label"
                        id="accessibility-select"
                        value={reservation['reservationStatus']}
                        label="Accessibility"
                        onChange={(event) => {
                            const e = event.target.value
                            setReservation(
                                (reservation)=>{
                                 
                                 return {
                                     ...reservation,
                                     reservationStatus: e
                                 }
                                }
                             )
                        }}
                       
                    >
                        <MenuItem value={'pending'}>pending</MenuItem>
                        <MenuItem value={'confirmed'}>confirmed</MenuItem>
                        {/* New phone bookings can only be pending or confirmed */}
                        {isEdit && <MenuItem value={'fulfilled'}>fulfilled</MenuItem>}
                        {isEdit && !isFinal && <MenuItem value={'canceled'}>canceled</MenuItem>}
                    </Select>
                    </>:null
                    }
                    
                    </FormControl>

                    {reservation['accessibilityNotes'] && (
                      <TextField
                        id="accessibility-notes"
                        label="Dietary & Accessibility Notes"
                        disabled={customerLocked}
                        value={reservation['accessibilityNotes'] || ''}
                        multiline
                        fullWidth
                        InputProps={{ readOnly: true }}
                        variant="outlined"
                        sx={{ margin: 1 }}
                      />
                    )}

                <FormControl   sx={{
                        margin:1,
                        minWidth:120
                       }}>
                    <InputLabel id="input-area"> Area </InputLabel>
                    
                    <Select
                        labelId="area-label"
                        id="accessibility-area"
                        value={reservation['area']}
                        label="Accessibility"
                        onChange={(event) => {
                            const e = event.target.value
                            
                            setReservation(

                                (reservation)=>{
                                 
                                 return {
                                     ...reservation,
                                     area: e
                                 }
                                }
                             )
                        }}
                      
                    >
                        <MenuItem value={'Inside'}>Inside</MenuItem>
                        <MenuItem value={'Outside'}>Outside</MenuItem>
                      
                    </Select>
                    


                    </FormControl>
                    <FormControl   sx={{
                        margin:1,
                        minWidth:120
                       }}>
                    <InputLabel id="input-area"> Occasion </InputLabel>

                    <Select
                        
                        labelId="occasion-label"
                        id="occasion-area"
                        value={reservation['occasion']}
                        label="Occasion"
                        onChange={(event) => {
                            const e = event.target.value
                            
                            setReservation(

                                (reservation)=>{
                                 
                                 return {
                                     ...reservation,
                                     occasion: e
                                 }
                                }
                             )
                        }}
                      
                    >
           
                        <MenuItem value={'Birthday'}>Birthday</MenuItem>
                        <MenuItem value={'Anniversary'}>Anniversary</MenuItem>
                        <MenuItem value={'Date'}>Date</MenuItem>
                        <MenuItem value={'Corporate'}>Corporate</MenuItem>
                      
                    </Select>
                    </FormControl>

                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                   
                    <DatePicker
                    label="Date"
                   
                    value={reservation['reservationDate'] ? dayjs(new Date(reservation['reservationDate'])) : null}
                    format="DD/MM/YYYY"
                    onChange={(newValue) => {
                        if (!newValue || !newValue.isValid()) return
                        let e = newValue
                        setReservation(
                            (reservation)=>{
                                
                                return ({
                                    ...reservation,
                                    reservationDate: `${e.toDate()}`
                                })
                            }
                        )
                    }}
                    sx={{margin:1}}
                    />
                    
                {/* Native time inputs: the browser returns 24-hour "HH:mm" directly,
                    with no picker conversion (the MUI picker produced Time To +1h for
                    Daniel and is fiddly on touch screens). */}
                <TextField
                  id="reservation-time-from"
                  label="Time From"
                  type="time"
                  value={reservation['timeFrom'] || ''}
                  onChange={(e) => handleTimeFrom(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                  sx={{ margin: 1 }}
                />
                <TextField
                  id="reservation-time-to"
                  label="Time To"
                  type="time"
                  value={reservation['timeTo'] || ''}
                  onChange={(e) => handleTimeTo(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                  helperText={timeToAuto && reservation['timeTo'] ? "Set to 2 hours after Time From (you can change it)" : " "}
                  sx={{ margin: 1 }}
                />
                </LocalizationProvider>

                    
                
                      {/* </LocalizationProvider> */}
                    </DialogContent>
                    {saveError ? (
                      <Alert severity="error" role="alert" sx={{ mx: 2, mb: 1 }}>
                        {saveError}
                      </Alert>
                    ) : null}
                    <DialogActions>
                    <Button autoFocus disabled={saving} onClick={()=>handle_save(reservation)}>
                        {saving ? 'Saving…' : props.reservation?'Save changes':'Save'}
                    </Button>
                    </DialogActions>
                  </BootstrapDialog>



        </>
    )
}

export default EditReservationModal